export default (tracker) => ({
  async declared({ category, source }) {
    await tracker.track('Attribution Declared', {
      attribution_category: category,
      attribution_source: source,
    })
  },
})
